/* global Blockly */
import React from 'react';
import {cameraIcon} from "./index";

// everything here should be ES5
function defineBlock(context) {
    return {
        init: function () {
            this.appendDummyInput('VALUE')
                .appendField('reset camera')
                .appendField(new Blockly.FieldImage(cameraIcon, 50, 30, 'camera icon', null), 'cameraIcon')
                .appendField(new Blockly.FieldWidgetsDropdown(context,'camera', undefined, '- select -'), 'DD');
            this.setPreviousStatement(true);
            this.setNextStatement(true);
            this.setOutput(false);
            this.setColour(Blockly.Msg.WIDGET_VALUES_HUE);
            this.setTooltip('Reset the selected camera widget');
        },
        onchange: function(){
            if (this.getField('cameraIcon') && this.getField('cameraIcon').imageElement_)
                this.getField('cameraIcon').setTooltip('Camera');
        }
    }
}

// everything here should be ES5
function defineGenerators() {
    return {
        'JavaScript': function (block) {
            const id = block.getFieldValue('DD');
            const code = `Snap.widgets.camera.reset('${id}');\n`;

            return code;
        }
    }
}

const ResetCamera = function (props) {
    const name = 'snap_reset_camera';
    ResetCamera.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    if (!props.widgets || props.widgets.length < 1) {
        return null;
    }

    return (
        <block type={name}>
            {
                props.widget && (props.widget.id !== undefined) ?
                    <field name='DD'>{props.widget.id}</field>
                    : null
            }
        </block>
    );
}

export default ResetCamera;
